// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__X9pz4","submit":"styles_submit__n+EmY"};